import { Box, TextField } from "@mui/material"
import useFetchWithMsal from "../hooks/useFetchWithMsal"
import { useState, useEffect } from "react"
import { CSVLink } from "react-csv"

// Utility function to format a single record into a flat CSV row
const formatRow = (record) => {
  return {
    // Passed from schedule or delivery
    GrowerNumber: record.growerID || "",
    GrowerName: record.growerName || "",
    Contract: record.contract || "",
    Appellation: record.appellation || "",
    District: record.district, // using last two characters
    Variety: record.variety || "",
    Program: record.programCode || "",
    Cert: record.certification || "",
    Block: record.block,
    ScheduledLoads: record.scheduledLoads || 0,
    DeliveredLoads: record.deliveredLoads || 0,
    "H/M": "",
    MinBrix: record.minBrix || "",
    MaxBrix: record.maxBrix || "",
    "Trucking Co.": "",
    RepName: record.growerRep || "",
    Count: "",
    "Crus.": "",
    "3&4 Total Loads": "",
    "1&2 Total Loads": "",
    "Dump Times": "",
    "Last Day": "",
  }
}

const DDSReport = () => {
  const [reportData, setReportData] = useState([])
  const [selectedDate, setSelectedDate] = useState("") // Default to today
  const { execute: executeGetDDSReport, data, isLoading } = useFetchWithMsal()

  const headers = [
    { label: "GrowerNumber", key: "GrowerNumber" },
    { label: "GrowerName", key: "GrowerName" },
    { label: "Contract", key: "Contract" },
    { label: "Appellation", key: "Appellation" },
    { label: "District", key: "District" },
    { label: "Variety", key: "Variety" },
    { label: "Program", key: "Program" },
    { label: "Cert", key: "Cert" },
    { label: "Block", key: "Block" },
    { label: "ScheduledLoads", key: "ScheduledLoads" },
    { label: "DeliveredLoads", key: "DeliveredLoads" },
    { label: "H/M", key: "H/M" },
    { label: "MinBrix", key: "MinBrix" },
    { label: "MaxBrix", key: "MaxBrix" },
    { label: "Trucking Co.", key: "Trucking Co." },
    { label: "RepName", key: "RepName" },
    { label: "Count", key: "Count" },
    { label: "Crus.", key: "Crus." },
    { label: "3&4 Total Loads", key: "3&4 Total Loads" },
    { label: "1&2 Total Loads", key: "1&2 Total Loads" },
    { label: "Dump Times", key: "Dump Times" },
    { label: "Last Day", key: "Last Day" },
  ]

  // Set default date to today on mount
  useEffect(() => {
    const today = new Date()
    const yyyy = today.getFullYear()
    const mm = String(today.getMonth() + 1).padStart(2, "0")
    const dd = String(today.getDate()).padStart(2, "0")
    setSelectedDate(`${yyyy}-${mm}-${dd}`)
  }, [])

  // Fetch DDS report whenever selectedDate changes
  useEffect(() => {
    if (!selectedDate) return
    const fetchReport = async () => {
      try {
        await executeGetDDSReport(
          "GET",
          `/api/gr/reports/dds?date=${selectedDate}`
        )
      } catch (error) {
        console.error("Error fetching DDS report:", error)
      }
    }
    fetchReport()
  }, [selectedDate, executeGetDDSReport])

  // Format and store report data when API response arrives
  useEffect(() => {
    if (data && !isLoading) {
      setReportData(data.map((row) => formatRow(row)))
    }
  }, [data, isLoading])

  return (
    <Box sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <TextField
        type="date"
        label="Select Date"
        value={selectedDate}
        onChange={(e) => {
          setSelectedDate(e.target.value)
        }}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{ marginBottom: 2 }}
      />
      {selectedDate && (
        <Box sx={{ marginBottom: 2 }}>
          <CSVLink
            data={Array.isArray(reportData) ? reportData : []}
            headers={headers}
            className="btn btn-primary"
            style={{ width: "300px", alignSelf: "center" }}
            filename={
              selectedDate ? `dds_report-${selectedDate}.csv` : "dds_report.csv"
            }
          >
            Download Report
          </CSVLink>
        </Box>
      )}
    </Box>
  )
}

export default DDSReport
